import { render, staticRenderFns } from "./mailboxSwitch.vue?vue&type=template&id=dbe0316c&scoped=true"
import script from "./mailboxSwitch.vue?vue&type=script&lang=js"
export * from "./mailboxSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe0316c",
  null
  
)

export default component.exports